"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatAccess(object) {
    return checkExternalChatAccess(object).fulfilled;
}
exports.isExternalChatAccess = isExternalChatAccess;
function checkExternalChatAccess(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("userId"), __1.hasArray("channels", __1.isString()), __1.hasArray("users", __1.isString())).withOptions(options).explain();
}
exports.checkExternalChatAccess = checkExternalChatAccess;
//# sourceMappingURL=ExternalChatAccess.js.map